import type { ShiftProductionForm, ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";

type Queue = { items: ShiftProductionFormListItem[]; total: number };

// Navigation reads are separate from the committed decision; retrying them never writes.
export async function loadNextApproval(
  decidedId: string,
  loadQueue: () => Promise<Queue>,
  loadForm: (id: string) => Promise<{ form: ShiftProductionForm }>,
) {
  const queue = await loadQueue();
  const next = queue.items.find(item => item.id !== decidedId);
  const detail = next ? await loadForm(next.id) : null;
  return { queue, form: detail?.form ?? null };
}
